/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import NumberHelper from '../number';

class DateHelper {
  static getRandomDateDescriptionBetween(startstamp, endstamp) {
    const startDate = this.datestampToDate(startstamp);
    const endDate = this.datestampToDate(endstamp);
    const resultDate = this.getRandomDateBetween(startDate, endDate);
    return this.dateToDescription(resultDate);
  }
  static getRandomDateBetween(startDate, endDate) {
    return new Date(startDate.getTime() + Math.random() * (endDate.getTime() - startDate.getTime()));
  }

  static timestampToHumanReadableString(timestamp) {
    let date = new Date(timestamp);
    return this.dateToDescription(date);
  }

  static timestampToEditableString(timestamp) {
    timestamp = timestamp * 1000;
    let date = new Date(timestamp);
    return this._dateToEditableString(date);
  }

  static serverTimestampToInt(timestamp) {
    return new Date(timestamp).getTime();
  }
  static _dateToEditableString(date) {
    let days = date.getDate();
    let months = date.getMonth() + 1;
    let year = date.getFullYear();
    days = NumberHelper.addZerosUntilLength(days, 2);
    months = NumberHelper.addZerosUntilLength(months, 2);
    return days + '-' + months + '-' + year;
  }
  static editableStringToTimestamp(string) {
    let parts = string.split('-');
    let day = parseInt(parts[0]);
    let month = parseInt(parts[1]);
    let year = parseInt(parts[2]);
    let date = new Date(year, month - 1, day);
    return date.getTime() / 1000;
  }

  static currentDateToHumanReadableString() {
    return this.dateToDescription(new Date());
  }

  static datestampToDate(datestamp) {
    const parts = datestamp.split('-');
    const year = parseInt(parts[0]);
    const month = parseInt(parts[1] - 1);
    const day = parseInt(parts[2]);
    return new Date(year, month, day);
  }
  static dateToDescription(date) {
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();
    return day + ' ' + monthNames[monthIndex] + ' ' + year;
  }

  static getHourFromDate(timestamp) {
    let date = new Date(timestamp);
    let hours = date.getUTCHours();
    if (hours % 10 === hours) {
      hours = '0' + hours;
    }
    let minutes = date.getMinutes();
    if (minutes % 10 === minutes) {
      minutes = '0' + minutes;
    }
    return hours + ':' + minutes + ' UTC';
  }

  // calculates UTC timestamp at midday hour
  static getUtcMiddayTime(isoString = new Date().toISOString()) {
    const isoStringLocalTimeIgnored = isoString.split('T')[0];
    const midDayHour = 'T12:00:00Z';
    const utcTime = new Date(isoStringLocalTimeIgnored + midDayHour).getTime();

    return utcTime;
  }

  // transforms local date to UTC and ignores offset (helpful to keep the same calendar day)
  static removeOffsetTime(localDate = new Date(), offsetInMinutes = new Date().getTimezoneOffset()) {
    const offsetInMs = offsetInMinutes * 60 * 1000; // offset converted to ms
    const dateWithOffsetRemoved = new Date(localDate - offsetInMs);

    return dateWithOffsetRemoved.toISOString();
  }

  // transforms UTC date by adding the local offset
  static addOffsetTime(utcDate = new Date()) {
    const todayLocalDate = new Date();
    const offsetInMs = todayLocalDate.getTimezoneOffset() * 60 * 1000; // offset is in minutes - needed to convert to ms
    const dateWithOffsetAdded = new Date(Number(utcDate) + offsetInMs);

    return dateWithOffsetAdded.toISOString();
  }

  static getEndOfTodayTimestamp() {
    const oneDayInMs = 24 * 60 * 60 * 1000;
    const today = new Date();
    const startOfToday = Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate());
    const startOfTomorrow = startOfToday + oneDayInMs;

    return startOfTomorrow - 1;
  }
}

export default DateHelper;
